module.exports = __webpack_public_path__ + "static/media/calendar.63ea6ca8.svg";